import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import Enums from 'utils/EnumsManager';
import { BackToPrev, Panel, Section } from 'components/ui/index';
import Sider from 'components/page/FilterCriteria/components/Sider/index';
import { resetWidth } from 'components/page/EnhancedSider/flow/actions';
import { toggleRightSider } from 'components/page/RightSider/flow/action';
import RuleSetup from '../components/RuleSetup';
import WorkFlowCriteria from '../components/WorkFlowCriteria';
import TriggerActions from '../components/TriggerActions/index';
import ActionGroup from '../components/ActionGroup';
import {
  fetchWorkFlowData,
  resetSiderData,
  updateCriteriaByColumn,
  updateTriggerActionFilterValue,
  reset
} from '../flow/action';

const { PhantomId, WorkFlow } = Enums;
const { ActionValueType } = WorkFlow;
const { FILTERVALUE } = ActionValueType;

const defaultProps = {};
const propTypes = {
  workFlowId: PropTypes.string.isRequired,
  rightSiderValue: PropTypes.object.isRequired,
  fetchWorkFlowData: PropTypes.func.isRequired,
  resetSiderData: PropTypes.func.isRequired,
  resetWidth: PropTypes.func.isRequired,
  toggleRightSider: PropTypes.func.isRequired,
  updateCriteriaByColumn: PropTypes.func.isRequired,
  updateTriggerActionFilterValue: PropTypes.func.isRequired,
};

class AddAndEditWorkFlow extends React.Component {
  componentDidMount() {
    const { workFlowId, fetchWorkFlowData } = this.props;
    fetchWorkFlowData(workFlowId);
  }

  componentWillUnmount() {
    const { reset } = this.props;
    reset();
  }

  validateRuleForm = () => {
    let formErrors = {};
    this.ruleFormValidation((errors, values) => formErrors = errors);
    return formErrors;
  };

  handleSiderValueChange = (value, displayNum) => {
    const { rightSiderValue, updateTriggerActionFilterValue, updateCriteriaByColumn } = this.props;
    const { sessionNum } = rightSiderValue;
    if (sessionNum !== null) {
      updateTriggerActionFilterValue(sessionNum, displayNum, value, FILTERVALUE);
    } else {
      updateCriteriaByColumn('value', displayNum, value);
    }
  }

  hadleSiderClose = () => {
    const { resetSiderData, resetWidth, toggleRightSider } = this.props;
    resetWidth('right');
    toggleRightSider(true);
    resetSiderData();
  }

  render() {
    const {
      workFlowId,
      rightSiderValue,
      metaFields,
      criteria
    } = this.props;
    const sessions = [
      {
        key: 'setup',
        title: (<FormattedMessage id="page.WorkFlow.ruleSetup">{text => <span>1. {text}</span>}</FormattedMessage>),
        child: <RuleSetup ruleFormRef={v => this.ruleFormValidation = v} workFlowId={workFlowId} />
      },
      {
        key: 'criteria',
        title: (<FormattedMessage id="page.WorkFlow.criteria">{text => <span>2. {text}</span>}</FormattedMessage>),
        child: <WorkFlowCriteria />
      },
      {
        key: 'triggerActions',
        title: (<FormattedMessage id="page.WorkFlow.triggerActions">{text => <span>3. {text}</span>}</FormattedMessage>),
        child: <TriggerActions workFlowId={workFlowId} hadleSiderClose={this.hadleSiderClose} />
      }
    ];

    return (
      <React.Fragment>
        <BackToPrev
          backLink="/setup/settings/workflow"
          backText={<FormattedMessage id="page.WorkFlow.backToWorkFlowList" />}
        />
        <Panel
          panelTitle={<FormattedMessage id={`page.WorkFlow.${workFlowId === PhantomId ? 'addWorkFlow' : 'editWorkFlow'}`} />}
        >
          {sessions.map(session => (
            <Section key={session.key} title={session.title}>
              {session.child}
            </Section>
          ))}
          <ActionGroup
            workFlowId={workFlowId}
            metaFields={metaFields}
            criteria={criteria}
            validateRuleForm={this.validateRuleForm}
          />
        </Panel>
        <Sider
          rightSiderValue={rightSiderValue}
          hadleSiderClose={this.hadleSiderClose}
          handleValueChange={this.handleSiderValueChange}
        />
      </React.Fragment>
    );
  }
}
AddAndEditWorkFlow.defaultProps = defaultProps;
AddAndEditWorkFlow.propTypes = propTypes;

const mapStateToProps = ({ global, setup }) => {
  const { workFlowCriteria, metaData } = setup.workFlow;
  return {
    lang: global.language,
    metaFields: metaData.criteriaMetaData.fields,
    criteria: workFlowCriteria.criteria,
    rightSiderValue: setup.workFlow.metaData.sider,
}};
const mapDispatchToProps = {
  fetchWorkFlowData,
  resetSiderData,
  resetWidth,
  toggleRightSider,
  updateCriteriaByColumn,
  updateTriggerActionFilterValue,
  reset
};

export default connect(mapStateToProps, mapDispatchToProps)(AddAndEditWorkFlow);



// WEBPACK FOOTER //
// ./src/views/Setup/WorkFlow/container/AddAndEditWorkFlow.jsx